import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { DEFAULT_CONVERSATION_NAME } from "../../constants";
var ConversationTitle = function (props) {
    var currentUser = localStorage.getItem("email");
    var filteredParticipants = props.participants.filter(function (participant) { return participant.identity !== currentUser; });
    var t = useTranslation(["chat"]).t;
    var firstThreeParticipants = filteredParticipants.slice(0, 3);
    var identities = firstThreeParticipants
        .map(function (participant) { return participant.identity; })
        .join(", ");
    var Participants = function () { return (
    /**
     * Maybe find better way later
     * we keep this quick
     */
    _jsxs(_Fragment, { children: [filteredParticipants.length === 1 && (_jsx("p", { className: "first-participant", children: identities })), filteredParticipants.length === 2 && (_jsx("p", { className: "first-participant", children: 
                /* @ts-ignore */
                firstThreeParticipants.find(function (participant) { return participant.identity !== currentUser; }).identity })), filteredParticipants.length === 3 && (_jsx("p", { className: "first-participant", children: identities })), filteredParticipants.length > 3 && (_jsxs(_Fragment, { children: [_jsx("p", { className: "first-participant", children: identities }), _jsxs("p", { className: "more-participants", children: ["+ ", filteredParticipants.length - 3, " ", t("personnes")] })] })), filteredParticipants.length === 0 && (_jsx("p", { className: "no-participant", children: t("No participant") }))] })); };
    return (_jsx(_Fragment, { children: props.title !== DEFAULT_CONVERSATION_NAME ? (props.title) : (_jsx(Participants, {})) }));
};
export default ConversationTitle;
